export enum UserInfoRouteNames {
	Address = "change-address",
	PhoneNumber = "change-phone",
	EmailAddress = "change-email"
}

export enum userAction {
	OnUserType = "OnUserType",
	OnFocusOut = "OnFocusOut"
}

export enum RequestApiFrom {
	RequestSmsCode = "RequestSmsCode",
	PostNewEmail = "PostNewEmail",
	ConfirmEmail = "ConfirmEmail",
	PostNewAddress = "PostNewAddress"
}

export interface ChangeAddressModel {
	street: string;
	street_line_2?: string;
	city: string;
	country: string;
	zipcode: string;
	manual_address: boolean;
	sms_pin_code?: string;
	auth_code?: string;
}

export interface OldAddressModel {
	street: string;
	street_line_2: string;
	city: string;
	zipcode: string;
	country: string;
	isoCountry: string;
}
